import { ServiceInstructionFormType } from 'components/service-instructions/ServiceInstructionForm';

export const updateServiceInstructionInitialValues: Partial<ServiceInstructionFormType> = {};
